import { render, staticRenderFns } from "./DetailCampusBannierMapBlock.vue?vue&type=template&id=11407495"
import script from "./DetailCampusBannierMapBlock.vue?vue&type=script&lang=js"
export * from "./DetailCampusBannierMapBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports